module.exports = __webpack_public_path__ + "img/20210828_213841.b9bd6b06.jpg";